import { frFR, deDE, itIT, enUS, PickersLocaleText } from "@mui/x-date-pickers/locales";

export const localeMap: Record<string, Partial<PickersLocaleText>> = {
  fr: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  de: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
  it: itIT.components.MuiLocalizationProvider.defaultProps.localeText,
  en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
};
